<template>
  <v-container fluid class="pa-4">
    <v-row>
      <v-col cols="12">
        <v-alert :value="alert" type="success">Başarıyla kaydedildi.</v-alert>

        <v-card>
          <v-card-title class="pb-2">
            <v-icon left>link</v-icon>
            {{ isEditMode ? 'MP Şirket Eşleştirme Düzenle' : 'Yeni MP Şirket Eşleştirme' }}
          </v-card-title>

          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="model.tenantId"
                    :items="tenantOptions"
                    item-text="tenantName"
                    item-value="tenantId"
                    label="Tenant *"
                    outlined
                    dense
                    :rules="requiredRules"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="model.mpId"
                    :items="marketplaceOptions"
                    item-text="mpName"
                    item-value="mpId"
                    label="Pazaryeri *"
                    outlined
                    dense
                    :rules="requiredRules"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="model.companyId"
                    :items="companyOptions"
                    item-text="name"
                    item-value="id"
                    label="Şirket *"
                    outlined
                    dense
                    :loading="companiesLoading"
                    :disabled="companiesLoading"
                    :rules="requiredRules"
                  />
                </v-col>
              </v-row>

              <v-row class="mt-4">
                <v-col cols="12">
                  <v-btn color="success" @click="save" :loading="saving" :disabled="!valid" class="mr-2">
                    <v-icon left>save</v-icon>
                    Kaydet
                  </v-btn>
                  <v-btn color="grey" text @click="goBack">
                    <v-icon left>arrow_back</v-icon>
                    Geri Dön
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import mpCompaniesApi from '@/api/mpCompanies';
import companiesApi from '@/api/companies';

const DEFAULT_TENANTS = [
  { tenantId: 1, tenantName: 'ALTINDAFIRSAT' },
  { tenantId: 2, tenantName: 'E-ALTIN' },
];

const DEFAULT_MARKETPLACES = [
  { mpId: 1, mpName: 'Hepsiburada' },
  { mpId: 2, mpName: 'Alışgidiş' },
  { mpId: 3, mpName: 'Trendyol' },
  { mpId: 4, mpName: 'Idefix' },
  { mpId: 5, mpName: 'Idia' },
];

export default {
  data() {
    return {
      valid: false,
      alert: false,
      saving: false,
      companiesLoading: false,
      tenantOptions: DEFAULT_TENANTS,
      marketplaceOptions: DEFAULT_MARKETPLACES,
      companyOptions: [],
      model: {
        id: null,
        tenantId: null,
        mpId: null,
        companyId: null,
      },
      requiredRules: [
        (v) => v !== null && v !== undefined && v !== '' || 'Bu alan zorunludur',
      ],
    };
  },
  computed: {
    isEditMode() {
      return !!this.$route.params.id;
    },
  },
  methods: {
    goBack() {
      this.$router.push('/admin/mp-companies');
    },
    async loadCompanies() {
      this.companiesLoading = true;
      try {
        const res = await companiesApi.getCompanies();
        this.companyOptions = res && res.data ? res.data : [];
      } catch (e) {
        this.companyOptions = [];
      } finally {
        this.companiesLoading = false;
      }
    },
    async load() {
      if (!this.isEditMode) return;
      try {
        const res = await mpCompaniesApi.getMpCompany(this.$route.params.id);
        this.model = Object.assign({}, this.model, res && res.data ? res.data : {});
      } catch (e) {
        this.$store.state.dialog = true;
        this.$store.state.message = 'Kayıt alınamadı.';
        this.goBack();
      }
    },
    async save() {
      if (!this.$refs.form.validate()) return;
      this.saving = true;
      try {
        const payload = {
          tenantId: this.model.tenantId,
          mpId: this.model.mpId,
          companyId: this.model.companyId,
        };
        if (this.isEditMode) {
          await mpCompaniesApi.putMpCompany(this.$route.params.id, payload);
        } else {
          await mpCompaniesApi.postMpCompany(payload);
        }
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
          this.goBack();
        }, 1200);
      } catch (e) {
        this.$store.state.dialog = true;
        this.$store.state.message = 'Kaydetme sırasında hata oluştu.';
      } finally {
        this.saving = false;
      }
    },
  },
  async mounted() {
    await this.loadCompanies();
    await this.load();
  },
};
</script>

